// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"cc8d18af","38":"8e751125","443":"0d813196","453":"a77ee037","467":"bb361f75","499":"08660a9f","545":"71740ed5","555":"1ad6b53d","642":"cb6653c6","674":"95f9708e","854":"9807c670"}[chunkId] + ".chunk.js";
};